import React from 'react';
import ReactDOM from 'react-dom';

import { App } from 'containers/App';
import { ruIntl } from 'i18n/ru';
import { productionServices } from 'services/production';

const { NODE_ENV, REACT_APP__SERVICES_TYPE: SERVICES_TYPE } = process.env;

export const renderApp = async () => {
  if (SERVICES_TYPE === 'production' || NODE_ENV === 'production') {
    ReactDOM.render(
      <App services={productionServices} intl={ruIntl} />,
      document.getElementById('root')
    );
  } else {
    // Импортируем mock-сервисы динамически, чтобы они не попадали в production-версию
    const { mockServices } = await import('services/mock');
    ReactDOM.render(
      <App services={mockServices} intl={ruIntl} />,
      document.getElementById('root')
    );
  }
};
